import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { LoadingBarOrEmptySpace } from 'components/common/loading/loading-bar-or-empty-space';
import { FC, ReactNode } from 'react';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Keeps the dialog up while the action runs, so the result lands on a dialog still on screen. */
  loading?: boolean;
  /** For dialogs whose confirm needs a choice made first, e.g. a number selected. */
  confirmDisabled?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading = false,
  confirmDisabled = false,
  maxWidth,
  fullWidth,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      aria-labelledby="confirm-dialog-title"
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{message}</DialogContentText>
      </DialogContent>
      <LoadingBarOrEmptySpace loading={loading} />
      <DialogActions>
        <Button
          onClick={onCancel}
          color="secondary"
          variant="contained"
          disabled={loading}
          autoFocus
        >
          {cancelLabel}
        </Button>
        <Button onClick={onConfirm} variant="contained" disabled={loading || confirmDisabled}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
